// we use custom heading size for hero banner
// eslint-disable-next-line no-restricted-imports
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import SearchBar from 'ui/snippets/searchBar/SearchBar';

export const BACKGROUND_DEFAULT =
  'radial-gradient(circle at 8% 15%, rgba(245, 154, 47, .95) 0, rgba(245, 154, 47, 0) 28%), linear-gradient(125deg, #07385B 0%, #0B568F 55%, #176FA8 100%)';

const HeroBanner = () => {
  return (
    <Flex
      w="100%"
      alignItems={{ base: 'flex-start', lg: 'flex-end' }}
      justifyContent="space-between"
      gap={{ base: 5, lg: 8 }}
      flexDir={{ base: 'column', lg: 'row' }}
      mb={{ base: 6, lg: 8 }}
    >
      <Box>
        <Heading
          as="h1"
          fontSize={{ base: '26px', lg: '36px' }}
          lineHeight={{ base: '36px', lg: '48px' }}
          fontWeight="700"
          color="text.primary"
        >
          نمای کلی شبکه
        </Heading>
        <Text color="text.secondary" mt={ 2 }>
          اطلاعات شبکه با ثبت هر بلاک جدید به‌روز می‌شود.
        </Text>
      </Box>
      <Box w={{ base: '100%', lg: '640px' }} flexShrink={ 0 }>
        <SearchBar isHomepage autoDirection/>
      </Box>
    </Flex>
  );
};

export default React.memo(HeroBanner);
